import { Dispatch, SetStateAction } from 'react';
import { ServiceType } from '../commonServiceOrder.types';
import { ServiceTypeFilter } from './ServiceTypeFilter';
import { LocationFilter, LocationValue } from '../../../sharedComponents/filter/LocationFilter';
import { DateRangeFilter } from '../../../sharedComponents/filter/DateRangeFilter';

export type LocalModalFilters = {
    startDateFilter: Date | string | undefined;
    endDateFilter: Date | string | undefined;
    serviceTypeFilter: ServiceType[];
    locationFilter: LocationValue;
};

type ServiceOrderFilterModalContentProps = {
    localFilters: LocalModalFilters;
    setLocalFilters: Dispatch<SetStateAction<LocalModalFilters>>;
};

export const ServiceOrderFilterModalContent = ({
    localFilters,
    setLocalFilters,
}: ServiceOrderFilterModalContentProps) => {
    return (
        <div className="margin-bottom-20">
            <DateRangeFilter
                timeframeFilterTitle="outboundPortal.serviceOrders.table.toolbar.filter.orderIssuedDate"
                startDateFilterName="startDateFilter"
                endDateFilterName="endDateFilter"
                startDate={localFilters.startDateFilter}
                endDate={localFilters.endDateFilter}
                setLocalFilters={setLocalFilters}
            />
            <hr className="margin-top-20 margin-bottom-20" />
            <div className="margin-bottom-20">
                <LocationFilter
                    value={localFilters.locationFilter}
                    onLocationChange={(locationFilter) => {
                        setLocalFilters((prevState) => ({ ...prevState, locationFilter }));
                    }}
                />
            </div>
            <div>
                <ServiceTypeFilter
                    value={localFilters.serviceTypeFilter}
                    onChange={(serviceTypeFilter) =>
                        setLocalFilters((prevState) => ({ ...prevState, serviceTypeFilter }))
                    }
                />
            </div>
        </div>
    );
};
